/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { pluginPostbackSetRefundStatusOrderStatusEnumSchema } from "./pluginPostbackSetRefundStatusOrderStatusEnumSchema.ts";

export const pluginPostbackSetRefundStatusOrderRequestSchema = z.object({
	groupId: z.uuid(),
	plugin_key: z.string().min(1),
	order_id: z.uuid(),
	status: pluginPostbackSetRefundStatusOrderStatusEnumSchema.describe("* `refunded` - refunded\n* `refund_failed` - refund_failed"),
	error_message: z.string().min(1).nullish(),
});
